import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Pin } from '../models/Pin';

@Injectable()
export class ShareDataService {


  private defaultSource = new BehaviorSubject(null);
  valuePines = this.defaultSource.asObservable();

  constructor() { }

  changePines(pines: Pin[]) {
    this.defaultSource.next(pines)
  }

}